export default __webpack_public_path__ + "static/media/BM_RenderCamera_19_CU_A+Interior+Detail+Bedroom.085ff450.jpg";